/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Members_Remove_Sole_Space_AdminInputs */



/**
* | output |
* | --- |
* | "This member is the only administrator of one or more shared spaces. Transfer ownership on their member page first." |
*
* @param {Members_Remove_Sole_Space_AdminInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const members_remove_sole_space_admin = /** @type {((inputs?: Members_Remove_Sole_Space_AdminInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Members_Remove_Sole_Space_AdminInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieses Mitglied ist der einzige Administrator eines oder mehrerer geteilter Spaces. Übertrage zuerst den Besitz auf der Seite des Mitglieds.")
	return /** @type {LocalizedString} */ ("This member is the only administrator of one or more shared spaces. Transfer ownership on their member page first.")
});